import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';

export const NotAvailableBillingProfiles = styled.div`
  margin-top: ${token('space.200')};
  // Override the border-bottom of custom panel header
  .custom-panel-wrapper-container .custom-panel-wrapper-v2 {
    border: none;
    > div > div:first-of-type {
      border-bottom: none;
      left: ${token('space.negative.200')};

      //increase the size of the chevron icon as per the design
      svg {
        width: ${token('space.400')};
        height: ${token('space.400')};
      }
    }
  }
`;
